import React from "react";
import Button from "../Button";

const RoundedButton = ({ style, ...rest }) => (
  <Button style={{ borderRadius: "1rem", ...style }} {...rest} />
);
export default RoundedButton;
